import { useCallback, useEffect } from "react";
import { To, useNavigate } from "react-router-dom";

import { signOut } from "../auth";
import { useAppContext } from "../providers/AppContext";

type Props = { to?: To; immediate?: boolean };

export const useLogout = (props?: Props) => {
  const navigate = useNavigate();
  const [, dispatch] = useAppContext();

  const logout = useCallback(
    async (to?: To) => {
      await signOut();
      dispatch({ type: "CLEAR" });
      to = to ?? props?.to;
      if (to != null) {
        navigate(to);
      }
    },
    [dispatch, navigate, props?.to],
  );

  useEffect(() => {
    if (props?.immediate) logout();
  }, [logout, props?.immediate]);

  return logout;
};
